<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="save"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Plinko Stage Config</span>
      </v-card-title>
      <v-card-text class="resizable-card__body">
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <v-text-field v-model.trim="model.key" label="Key" hide-details/>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-text-field v-model.number="model.points" label="Points" hide-details/>
          </v-col>
          <v-col cols="12" sm="2" md="2" class="mx-3">
            <v-btn @click="onPhysicsConfig" small color="success" class="my-1 fill-width">
              Physics Config
            </v-btn>
          </v-col>
        </v-row>
        <v-expansion-panels class="mt-4">
          <r-plinko-bucket-config-panel :items.sync="model.buckets" title="Buckets"/>
          <r-plinko-obstacle-config-panel :items.sync="model.obstacles" title="Obstacles"/>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text>
          Save
        </v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
    <r-plinko-physics-config-dialog ref="r-plinko-physics-config"/>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {PlinkoStageConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoStageConfig";
import RPlinkoBucketConfigPanel from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-bucket-config-panel.vue";
import RPlinkoObstacleConfigPanel from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-obstacle-config-panel.vue";
import RPlinkoPhysicsConfigDialog from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-physics-config-dialog.vue";

export default {
  name: "r-plinko-stage-config-dialog",
  components: { RPlinkoPhysicsConfigDialog, RPlinkoObstacleConfigPanel, RPlinkoBucketConfigPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(PlinkoStageConfig),
    rules: ViewRules.READONLY,
    dialogWidth: 690,
    dialogHeight: 338,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 690,
    resizeStartHeight: 338,
    viewportPadding: 32
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new PlinkoStageConfig();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
      this.stopResize();
    },
    onPhysicsConfig() {
      let data = this.model.physicsConfig ? this.model.physicsConfig.clone() : null;
      this.$refs['r-plinko-physics-config'].show(ViewRules.UPDATE, data).then(data => {
        this.model.physicsConfig = data;
      }).catch(() => {});
    },
    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },
    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;
      const minWidth = 450;
      const minHeight = 220;
      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;
      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },
    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__body {
  flex: 1;
  overflow: auto;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.fill-width {
  width: 100%;
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>